import styled from "styled-components";

import { Stack } from "shared/ui";
import { colors, radii } from "shared/ui/tokens";

export const List = styled(Stack).attrs({ $gap: 12 })`
    margin-bottom: 16px;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    flex-wrap: wrap;
    padding: 12px;
    border: 1px solid ${colors.borderSoft};
    border-radius: ${radii.base};
`;

export const Preview = styled.img`
    width: 162px;
    height: 108px;
    border-radius: 10px;
    object-fit: cover;
    flex: none;
`;

export const VideoPreview = styled.video`
    width: 162px;
    height: 108px;
    border-radius: 10px;
    object-fit: cover;
    flex: none;
    background: ${colors.borderSoft};
`;

export const Meta = styled.div`
    flex: 1 1 220px;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const MetaLabel = styled.span<{ $main?: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 700;
    color: ${({ $main }) => ($main ? colors.success : colors.fieldLabel)};
`;

export const Dot = styled.span`
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${colors.success};
`;

export const Actions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`;
